export const DEBOUNCE_TIME = {
  selection: 800,
  scroll: 100,
  sequenceTableResidueHover: 600,
  showFileDownloadModal: 2000,
  resize: 500,
  fullscreenLoader: 1000,
  ensureSessionIsValid: 50000,
  runningAlignmentLoader: 2000,
  showProcessingOnBlurLoader: 500,
  showFileUploadOnBlurLoader: 50,
  shortcut: 300,
};

export function sleep(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
